<template>
    <div class="content">
      <TruckersHistory />
    </div>
  </template>
  <script>
    import TruckersHistory from '../../components/Truckers/TruckerHistory.vue'
    
    export default {
      components: {
        TruckersHistory,
      },
      data () {
        return {
          
        }
      },
      methods:{
        
  
      }
    }
  </script>
  
  
  <style>
  .table {
      margin-left: 14px;
  }
  </style>
  